import {withoutTZ} from "../../utils/string-utils";

export const RXDB_QUOTE_SCHEMA = {
    title: 'Quote Schema',
    version: 6,
    type: 'object',
    primaryKey: '_id',
    properties: {
        _id: { type: 'string', maxLength: 100 },
        id: { type: 'string', maxLength: 100 },
        offlineId: { type: 'string', maxLength: 100 },
        creationDate: { type: ['string', 'null']},
        checkPointDate: { type: ['string', 'null'], default: null},
        reference: { type: ['string', 'null'] },
        totalWeeklyAmount: { type: ['string', 'null'] },
        totalMonthlyAmount: { type: ['string', 'null'] },
        serviceLines: {
            type: 'array',
            items: { type: 'object' }
        },
        clientInfos: { type: 'object' },
        status: { type: ['string', 'null'] },
        salesFileStatus: { type: ['string', 'null'] },
        type: { type: ['string', 'null'] },
        countryIsoCode: { type: ['string', 'null'] },
        standardPricingItemVersion: { type: ['string', 'null'] },
        regionCode: { type: ['string', 'null'] },
        regionLabel: { type: ['string', 'null'] },
        teamCode: { type: ['string', 'null'] },
        teamLabel: { type: ['string', 'null'] },
        roleCode: { type: ['string', 'null'] },
        employee: { type: 'object' },
        opportunityLabel: { type: ['string', 'null'] },
        opportunityId: { type: ['string', 'null'] },
        opportunityOfflineId: { type: ['string', 'null'] },
        isMainQuote: { type: ['boolean', 'null'] },
        nonNegociableArticleColor: { type: ['string', 'null'] },
        currency: { type: ['string', 'null'] },
        color: { type: ['string', 'null'] },
        existingColor: { type: ['string', 'null'] },
        eforceOpportunityId: { type: ['string', 'null'] },
        opportunityCreationDate: { type: ['string', 'null'] },
        opportunityType: { type: ['string', 'null'] },
        clientSize: { type: ['string', 'null'] },
        contractId: { type: ['string', 'null'] },
        contractReference: { type: ['string', 'null'] },
        nonReferencedCmcProtocolCode: { type: ['string', 'null'] },
        cmcProtocolCode: { type: ['string', 'null'] },
        cmcProtocolName: { type: ['string', 'null'] },
        cmcProtocolComment: { type: ['string', 'null'] },
        cmcUniqueReference: { type: ['boolean', 'null'] },
        isSynchronized: { type: ['boolean', 'null'] },
        personalization: {
            type: ['object', 'null'],
            additionalProperties: true
        },
        locale: { type: 'string', maxLength: 50 },
        speciality:  { type: ['string', 'null'] }
        },
    required: ['_id']
};

export const QuoteMigrations = {
    1: (oldDoc: any) => {
        return {
            ...oldDoc,
            checkPointDate: withoutTZ(oldDoc.checkPointDate) ?? withoutTZ(oldDoc.creationDate)
        };
    },
    2: (oldDoc: any) => {
        return {
            ...oldDoc,
            opportunityType: "NEW"
        };
    },
    3: (oldDoc: any) => {
        return {
            ...oldDoc,
            locale: "fr-FR"
        };
    },
    4: (oldDoc: any) => {
        oldDoc.offlineId = oldDoc.temporaryId;
        delete oldDoc.temporaryId;
        return oldDoc;
    },
    5: (oldDoc: any) => {
        delete oldDoc.sendEmail;
        return oldDoc;
    },
    6: (oldDoc: any) => {
        return {
            ...oldDoc,
            speciality: null
        };
    }
};

